<template>
  <div class="mySubscribe">
    <div class="account-card">
      <div class="account-card-header">
        <p
          @click="changeTab(0)"
          :class="
            active === 0 ? 'account-card-title active' : 'account-card-title'
          "
        >
          我的订阅公告
        </p>
        <p
          @click="changeTab(1)"
          :class="
            active === 1 ? 'account-card-title active' : 'account-card-title'
          "
        >
          我的订阅设置
        </p>
      </div>
      <div class="content">
        <component v-bind:is="activeComp"></component>
      </div>
    </div>
  </div>
</template>
<script>
import Notice from './components/notice.vue'
import Setting from './components/setting.vue'
export default {
  name: 'MySubscribe',
  components: {
    Notice,
    Setting
  },
  data() {
    return {
      activeComp: 'Notice',
      active: 0
    }
  },
  created() {
    const query = this.$route.query
    console.log(query)
    if (query.activeComp) {
      this.activeComp = query.activeComp
      this.active = 1
    }
  },
  methods: {
    changeTab(e) {
      if (e !== this.active) {
        this.active = e
        this.activeComp = this.activeComp === 'Notice' ? 'Setting' : 'Notice'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.mySubscribe {
  .account-card-header {
    display: flex;
  }

  .account-card-title {
    margin-right: 10px;
    cursor: pointer;
    font-weight: normal;
  }

  .active {
    font-weight: bold;
  }
}
</style>
